import { get, post } from './axios.js'

/**
 * lead 상세 조회 - /lead/leadSelect
 * @param {Object} params
 * @property {Number} params.ld_seq - lead seq
 * @returns
 */
export async function leadSelect(params = {}) {
  try {
    const result = await post('/lead/leadSelect', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}


/**
 * lead 목록 조회 - /lead/leadList
 * @param {Object} params
 * @property {string} params.usr_nm - 이름
 * @property {string} params.mobile - 핸드폰번호
 * @property {string} params.sales_boss - 영업대표
 * @property {string} params.company - 회사관리번호
 * @property {Number} params.page_count - page_count
 * @property {Number} params.unit_count - unit_count
 * @returns
 */
export async function leadList(params = {}) {
    try {
      const result = await post('/lead/leadList', params)
      return result.data
    } catch(e) {
      throw new Error(e)
    }
}
  

/**
 * 리드 등록/수정 - /lead/leadEdit
 * @param {Object} params
 * @property {string} params.ss_user_id - 로그인 유저 id
 * @property {Number} params.event_seq - 이벤트 매핑 seq
 * @property {string} params.usr_nm - 이름
 * @property {string} params.mobile - 핸드폰번호
 * @property {string} params.email - 이메일
 * @property {string} params.cmp_info_seq - 회사관리번호
 * @property {string} params.postion - 직책
 * @property {string} params.attn_cd - 관심분야
 * @property {string} params.indst_cd - 산업분야
 * @property {string} params.note - 메모
 * @property {string} params.sales_boss - 영업대표
 * @property {string} params.trend_cd - 성향 cd
 * @property {string} params.oprtn_cd - 영업기회(N:n/a,Convert:C,Omit:o)
 * @property {string} params.sales_id - 영업기회id
 * @property {string} params.omit_rst - omit사유
 * @property {string} params.enable_yn - (비)활성여부
 * @property {string} params.del_yn - 삭제여부
 * @property {string} params.tmp_yn - 임시저장(Y:임시저장,N:저장완료)
 * @returns
 */
export async function leadEdit(params = {}) {
    try {
      const result = await post('/lead/leadEdit', params)
      return result.data
    } catch(e) {
      throw new Error(e)
    }
}
  
